export default __webpack_public_path__ + "static/media/lynk_landing_draft.27a28617.jpg";